export const enGb = {
  checkoutBranding: "Checkout branding",
  edit: "Edit",
};
